import { Components, Theme } from '@mui/material/styles';
import scssVariables from '@styles/variables.module.scss';

export const MuiRating: Components<Theme>['MuiRating'] = {
  styleOverrides: {
    root: {
      '& .MuiRating-iconFilled': {
        color: scssVariables.ColorFog100,
      },
    },
  },
};
